import React from "react";
import ContentSection from "../../../../../components/Habitacional/ContentSection";
import Accordion from "../../../../../components/common/Accordion";
import Link from "../../../../../components/Habitacional/core/Link";
import { AccordionContent, AccordionItem } from "./Sections.Style";
import { envs } from "../../../../../config";

const AccordionListItemsLeft = [
  {
    title: "Quero entender mais sobre o meu seguro",
    body: (
      <>
        Criamos uma cartilha bem explicativa para te ajudar a entender mais
        sobre o seu seguro.{" "}
        <Link 
          href={`${envs.hostStaticCdn}/reguas/arquivos/seguro_habitacional_coberturas_e_assistencias.pdf`} 
          target="_blank" 
          rel="noreferrer">
            Baixe aqui
        </Link>.
      </>
    ),
  },
  {
    title: "Como acionar o meu seguro?",
    body: (
      <>
        Antes de acionar o seu seguro, recomendamos que assista a{" "}
        <Link href="https://www.youtube.com/watch?v=0t9yB6OJEgE" target="_blank" rel="noreferrer">este vídeo</Link> ou{" "}
        <Link
          href={`${envs.hostStaticCdn}/reguas/arquivos/seguro_habitacional_coberturas_e_assistencias.pdf`}
          target="_blank"
          rel="noreferrer">
          acesse este documento
        </Link>
        , que explicam tudo o que
        você precisa saber.
        <br />
        <br />
        Você pode fazer o seu pedido de indenização (acionar uma cobertura ou
        sinistro) <Link href="https://www.caixaseguradora.com.br/paravoce/habitacional/acionar_sinistro">diretamente em nosso site</Link>, pelo
        WhatsApp ou telefone. Confira os telefones e horários abaixo!
        <br />
        <br />
        WhatsApp <br />
        0800 749 2020 <br />
        Segunda a sexta, das 8h às 18h, exceto feriados. <br />
        <br />
        Telefone <br />
        0800 274 1000 <br />
        Assistência 24h, todos os dias da semana. <br />
        Sinistro; das 8h às 19h - segunda a sexta.
        <br />
        Demais serviços; das 8h às 21h - segunda a sexta, exceto em feriados
        nacionais <br />
      </>
    ),
  },
  {
    title: "Como acionar os serviços de assistência?",
    body: (
      <>
        Ligue para o telefone{" "}
        <Link href="tel:0800 274 1000">0800 274 1000</Link>, opção 2. O serviço
        está disponível 24 horas por dia.
      </>
    ),
  },
  {
    title: "Onde encontro informações sobre o meu financiamento imobiliário?",
    body: (
      <>
        Para informações sobre o seu financiamento imobiliário contratado na
        Caixa,{" "}
        <Link href="https://internetbanking.caixa.gov.br/sinbc/#!nb/login" target="_blank" rel="noreferrer">
          Internet Banking Caixa
        </Link>{" "}
        ou baixe o aplicativo Caixa. Se preferir, você pode procurar uma agência
        do banco, de preferência a que você já se relaciona.
      </>
    ),
  },
  {
    title:
      "O meu Seguro Habitacional cobre danos decorrentes de vícios de construção?",
    body: (
      <>
        Não. Podemos citar como vícios de construção a má conservação do imóvel,
        infiltrações e rachaduras, assim como prejuízos que ocorrem por falha na
        construção, a exemplo do uso inadequado de materiais e erros no projeto,{" "}
        ou por não atender às normas básicas instituídas pela Associação
        Brasileira de Normas Técnicas - ABNT.
        <br />
        <br />
        Veja a lista de todos os riscos excluídos nas condições gerais ao final
        desta página.
      </>
    ),
  },
  {
    title:
      "Como saber se o meu Seguro Habitacional cobre os bens presentes no interior da minha residência?",
    body: (
      <>
        Essa cobertura é conhecida por DFC (Danos Físicos ao Conteúdo) e garante
        a indenização em caso de prejuízos ao conteúdo presente dentro do imóvel
        segurado, decorrentes de incêndio, explosão, desmoronamento total ou
        parcial, entre outros fatos que sejam cobertos pelo seu seguro. Podemos
        citar como conteúdo os móveis (ex.: camas, armários e sofás);
        eletrodomésticos (ex.: geladeira, televisão e micro-ondas); além de
        objetos de uso pessoal (ex.: roupas e calçados) e doméstico (ex.:
        panelas e pratos). As modalidades que possuem essa cobertura são o
        Seguro Habitacional Mais e o Seguro Habitacional Mais Premiável. Para
        saber se você tem esse direito, verifique no seu contrato de
        financiamento o tipo de modalidade do seu seguro.
      </>
    ),
  },
];

const AccordionListItemsRight = [
  {
    title: "Posso alterar a forma de pagamento?",
    body: (
      <>
        Sim. Você pode optar por débito em conta Caixa ou pagamento em boleto. O
        seu seguro é cobrado junto com a parcela do seu financiamento e para
        fazer a alteração você precisa procurar uma agência Caixa.
      </>
    ),
  },
  {
    title: "Posso cancelar o meu seguro?",
    body: (
      <>
        Não. De acordo com a Lei 11.977/2009 e Resolução CNSP 447/2022, o Seguro
        Habitacional é obrigatório para todo o financiamento imobiliário.
        <br />
        <br />
        Ele garante a quitação da dívida do financiamento concedido pelo banco,
        assegurando que os recursos públicos (crédito imobiliário) estejam
        disponíveis para todos que necessitem financiar suas moradias. Vale
        destacar que, geralmente, o financiamento permanece por um longo período
        e, em caso de morte, invalidez permanente ou danos ao imóvel, o seguro
        garante a quitação ou amortização (antecipação do pagamento de parcelas
        futuras) do financiamento. <br />
        <br />
        Quando seu financiamento é quitado, o seguro é automaticamente
        encerrado.
      </>
    ),
  },
  {
    title: "O que o seguro habitacional não cobre?",
    body: (
      <>
        O seguro serve pra não te deixar no aperto. Se algo acontecer, nós
        daremos o suporte financeiro para reparar os prejuízos. Porém, a má
        conservação do imóvel, infiltrações e rachaduras não possuem coberturas,{" "}
        assim como os eventos que ocorrem por falha na construção ou por não
        atender as normas básicas instituidas pela{" "}
        <Link href="https://abnt.com.br" target="_blank" rel="noreferrer">
          Associação Brasileira de Normas Técnicas - ABNT
        </Link>
        .
      </>
    ),
  },
  {
    title:
      "Entenda como são as comissões de venda e as participações societárias dos intermediários para o Seguro Habitacional",
    body: (
      <>
        Nos termos da Resolução CNSP nº 382/2020, a Caixa Seguradora S.A.
        informa que a CAIXA, por meio de sua subsidiária integral Caixa
        Seguridade Participações S.A., detém participação societária direta
        sobre a Caixa Seguros HoldingS.A., no percentual de 48,21% e, indireta
        sobre a Wiz Soluções e Corretagem de Seguros S.A., no percentual de
        12,05%.
        <br />
        <br />
        Informamos ainda que a Caixa Seguros Holding S.A. detém participação
        societária direta sobre a Wiz Soluções e Corretagem de Seguros S.A., com
        percentual de 25%. A Caixa Seguros Holding – CSH remunera seus
        intermediários em até 9%, mediante pagamento de Tarifa Balcão,{" "}
        remuneração paga ao agente financeiro para o estímulo à indicação do
        Seguro Habitacional no seu balcão de vendas, no percentual de 5% e de
        Comissão paga à Corretora pela comercialização do seu Seguro
        Habitacional, no percentual de até 4%.
      </>
    ),
  },
  {
    title:
      "Qual a diferença entre acionar uma cobertura (sinistro) e solicitar serviços de assistência?",
    body: (
      <>
        Quando você aciona um sinistro, significa que houve danos ao seu imóvel,
        decorrentes de fatos significativos que sejam cobertos pelo seu seguro,{" "}
        como incêndio, explosão, vendaval, inundação, alagamento, entre outros.
        Já os serviços assistenciais são voltados para imprevistos que ocorrem
        no seu dia a dia. Por exemplo, se estourou algum cano na sua residência,
        você irá solicitar o serviço de um encanador. Já se você perder a chave
        da sua casa, você precisará da assistência de um chaveiro.
      </>
    ),
  },
];

const AccordionAboutYourInsurance = () => {
  return (
    <ContentSection title="Dúvidas sobre o meu seguro">
      <AccordionContent>
        <AccordionItem>
          <Accordion listItems={AccordionListItemsLeft} />
        </AccordionItem>
        <AccordionItem>
          <Accordion listItems={AccordionListItemsRight} />
        </AccordionItem>
      </AccordionContent>
    </ContentSection>
  );
};

export default AccordionAboutYourInsurance;
